<script lang="ts">
	import { EnterOnView } from '$lib/actions/animations/EnterOnView';
	import { createViewController, ViewController } from '$lib/actions/animations/ViewController';
	import { Intersection } from '$lib/actions/Intersection';
	import type { StatisticBlockType } from './StatisticBlockQuery';
	import gsap from 'gsap';
	const { data }: { data: StatisticBlockType } = $props();

	let ratio = $state({ value: 0 });

	function onEnter(entry: IntersectionObserverEntry) {
		if (entry.isIntersecting) {
			gsap.to(ratio, {
				duration: 1.5,
				value: 1,
				ease: 'power2.out'
			});
		}
	}

	function addCommas(x: number) {
		x = Math.round(x);
		return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
	}
	createViewController();
</script>

<section use:Intersection={{ onEnter }} use:ViewController>
	{#each data.items as item, i}
		<div class="item" use:EnterOnView={{ delay: i * 0.15 }}>
			<h3 class="text:description">{item.title}</h3>
			<p class="text:headline-huge">{addCommas(item.value * ratio.value)}</p>
		</div>
	{/each}
</section>

<style lang="scss">
	section {
		@include layoutBlockGrid;
		@include blockPadding;
	}

	h3 {
		width: 100%;
		padding-bottom: 16px;
		border-bottom: $border;
	}

	.item {
		padding: 36px;
		background-color: hsl(var(--color-backgroundMuted));

		grid-column: 1/-1;
		margin-bottom: 16px;
		@include md {
			grid-column: span 4;
			margin-bottom: 0;
		}
	}

	p {
		text-align: start;

		padding-top: 95px;
		@include md {
			padding-top: 106px;
		}
	}
</style>
